import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatShortDate } from '../../utils/dateUtils';
import { PolicyMember } from '../../services/api/folderService';

interface PolicyMemberItemProps {
    policy: PolicyMember;
}

const buildDateRange = (policy: PolicyMember, t: TFunction): string | null => {
    const effective = policy.effectiveDate
        ? formatShortDate(policy.effectiveDate)
        : null;
    const expiry = policy.expiryDate
        ? formatShortDate(policy.expiryDate)
        : null;
    if (effective && expiry) return `${effective} – ${expiry}`;
    if (effective) return t('folders.policy.effective', { date: effective });
    if (expiry) return t('folders.policy.expires', { date: expiry });
    return null;
};

export const PolicyMemberItem = ({ policy }: PolicyMemberItemProps) => {
    const { t } = useTranslation();
    const dateRange = buildDateRange(policy, t);

    return (
        <Link to={`/department-policies/${policy._id}`} className="block">
            <div className="flex flex-col px-4 py-3 transition-colors hover:bg-muted">
                <div className="text-sm font-medium text-foreground">
                    {policy.document_id?.title}
                </div>
                {dateRange && (
                    <div className="mt-0.5 text-xs font-medium text-subtle-foreground">
                        {dateRange}
                    </div>
                )}
            </div>
        </Link>
    );
};
